import { Box, styled } from '@mui/material';

import { colors } from '../../components';

export const PreviewContainer = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
    height: '100%',
}));

export const ImagePreview = styled('img')(() => ({
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
}));

export const TextPreviewBox = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    padding: theme.spacing(2),
    overflow: 'auto',
}));

export const TextPreviewTypography = styled('pre')(({ theme }) => ({
    ...theme.typography.caption,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    fontFamily: theme.typography.fontFamily,
    color: colors.fullBlack,
    margin: 0,
}));

export const MessageBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: theme.spacing(3),
    textAlign: 'center',
    gap: theme.spacing(2),
}));

/** Scrollable container for Office document preview (Excel table, Word HTML) */
export const OfficePreviewBox = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    minHeight: 0,
    overflow: 'auto',
    padding: theme.spacing(2),
    '& table': {
        ...theme.typography.body2,
        borderCollapse: 'collapse',
        width: '100%',
    },
    '& td, & th': {
        border: `1px solid ${colors?.greyPreset?.[40] || '#e0e0e0'}`,
        padding: theme.spacing(1, 1.5),
        textAlign: 'left',
    },
    '& th': {
        backgroundColor: colors?.greyPreset?.[100] || '#f5f5f5',
        fontWeight: 600,
    },
    '& tr:nth-of-type(even)': {
        backgroundColor: colors?.greyPreset?.[50] || '#fafafa',
    },
    '&.word-preview-content': {
        '& p': { margin: '0 0 0.5em 0' },
        '& ul, & ol': { margin: '0.5em 0', paddingLeft: '1.5em' },
        '& table': { borderCollapse: 'collapse', margin: '0.5em 0' },
        '& td, & th': { border: '1px solid #e0e0e0', padding: '4px 8px' },
    },
    '& .docx-preview-container': {
        '& .docx-preview': {
            color: '#000',
            backgroundColor: '#fff',
        },
    },
}));

export const ModalSx = {
    '& .footer-actions': {
        justifyContent: 'flex-end',
        '& .MuiButtonBase-root': {
            width: 'fit-content',
        },
    },
    '& .MuiDialogContent-root': {
        bgcolor: colors.bluePreset[110],
        borderRadius: 3,
        p: 2,
    },
};
